<div id="{{ createAttributeIdForConfigurator(attribute) }}" class="form-group">
  <div class="d-flex flex-column-reverse flex-sm-row">
    <udex-step-input
      *ngIf="!attribute?.uiTypeVariation?.endsWith(DcpUiType.READ_ONLY_QUANTITY); else readOnly"
      #quantityInput
      class="step-input"
      [class.max-content]="isErrorState((valueState$ | async) ?? '')"
      [attr.value]="attributeInputForm.value"
      [min]="quantityMetaData?.min"
      [step]="quantityMetaData?.interval"
      [max]="quantityMetaData?.max"
      [valueState]="valueState$ | async"
      value-precision="0"
      [supportingText]="
        !!getTranslationValues()
          ? (errorMessage | cxTranslate: {value: getTranslationValues()})
          : (errorMessage | cxTranslate)
      "
      [cxFocus]="{key: createAttributeIdForConfigurator(attribute)}"
      [attr.disabled]="isStepInputDisabled$ | async"
      [attr.required]="isStepInputRequired$ | async"
      (change)="onStepInputChange($event)"
      (value-state-change)="onValueStateChange($event)"></udex-step-input>
    <div>
      <ng-template #readOnly>
        <div class="d-flex align-items-center text-grey">
          {{ attribute.selectedSingleValue }}
        </div>
      </ng-template>
      <div
        class="min-input-height d-flex flex-row justify-content-start justify-content-sm-center align-items-center udex-ms-0 udex-ms-sm-16 text-grey"
        id="quantity-label">
        {{ quantityMetaData?.salesMetric }}
      </div>
      <ng-container *ngIf="this.quantityMetaData?.salesMetricTooltip">
        <ds-tooltip [content]="htmlTooltip" class="ds-tooltip my-auto"> </ds-tooltip>
        <ng-template #htmlTooltip><span [innerHtml]="this.quantityMetaData?.salesMetricTooltip"></span></ng-template>
      </ng-container>
    </div>
  </div>
  <div *ngIf="showQuantityMetaInfo$ | async" class="body--xxs udex-mt-4 udex-ps-12">
    <div
      *ngIf="
        quantityMetaData && quantityMetaData && quantityMetaData.min > 1 && quantityMetaData.interval > 1;
        else showSingleInformation
      ">
      {{
        'configurator.quantity.minimumWithIncrements'
          | cxTranslate
            : {
                value: quantityMetaData?.min,
                amount: quantityMetaData?.interval,
                unit: quantityMetaData?.salesMetric,
              }
      }}
    </div>
    <ng-template #showSingleInformation>
      <div *ngIf="quantityMetaData && quantityMetaData.min > 1">
        {{
          'configurator.quantity.minimumOf'
            | cxTranslate
              : {
                  value: quantityMetaData?.min,
                  unit: quantityMetaData?.salesMetric,
                }
        }}
      </div>
      <div *ngIf="quantityMetaData && quantityMetaData.interval > 1">
        {{
          'configurator.quantity.incrementsOf'
            | cxTranslate
              : {
                  amount: quantityMetaData?.interval,
                  unit: quantityMetaData?.salesMetric,
                }
        }}
      </div>
    </ng-template>
  </div>
  <div class="body--xxs udex-mt-4">
    <div *ngIf="quantityMetaData && quantityMetaData.max >= 1 && quantityMetaData.max < this.defaultMetaData.max">
      {{
        'configurator.quantity.maximumOf'
          | cxTranslate
            : {
                value: quantityMetaData?.max,
                unit: quantityMetaData?.salesMetric,
              }
      }}
    </div>
  </div>
</div>
